module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Fc-Ga-Ha-Ia-Gb.5830d0d1.png";